import React, { useState, useEffect } from 'react';
import T from '../../../components/common/T';
import { useParams, useNavigate } from 'react-router-dom';
import { useRoles } from '../../../context/RoleContext';
import { SYSTEM_MODULES } from '../../../config/moduleList';
// import Layout from '../../../components/Layout';
import { toast } from 'react-toastify';

// 🟢 SECURITY IMPORT
import { useAuth } from '../../../context/AuthContext';

const ViewRole = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { roles } = useRoles();
  const { checkAccess } = useAuth(); // 🟢 GET CHECKER
  
  const [roleName, setRoleName] = useState("");
  const [selectedPermissions, setSelectedPermissions] = useState([]);
  const [status, setStatus] = useState("Active");

  // 🟢 PAGE GUARD
  useEffect(() => {
    if (!checkAccess('role.view')) {
        toast.error("Access Denied: You do not have permission to view roles.");
        navigate('/admin/roles');
    }
  }, [checkAccess, navigate]);

  useEffect(() => {
    // Only load if allowed
    if(checkAccess('role.view')) {
        const roleToView = roles.find(r => r.id === parseInt(id));
        if (roleToView) {
        setRoleName(roleToView.name);
        setSelectedPermissions(Array.isArray(roleToView.permissions) ? roleToView.permissions : []); 
        setStatus(roleToView.status || "Active");
        } else {
        if(roles.length > 0) {
            toast.error("Role not found");
            navigate('/admin/roles');
        }
        }
    }
  }, [id, roles, navigate, checkAccess]);

  if (!checkAccess('role.view')) return null;

  return (
    <>
      <div className="p-6 bg-gray-50 min-h-screen font-sans">
        
        {/* Header */}
        <div className="max-w-6xl mx-auto mb-6 flex justify-between items-center">
          <div className="flex items-center gap-4">
             <h2 className="text-xlfont-bold text-gray-800"><T>View Role</T></h2>
             <span className="bg-emerald-100 text-emerald-800 text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider"><T>Read Only</T></span>
          </div>
          <span className="text-sm font-mono text-gray-400 bg-gray-100 px-3 py-1 rounded">ID: {id}</span>
        </div>

        <div className="max-w-6xl mx-auto bg-white p-8 rounded-xl shadow-lg border border-gray-100">
            
          {/* Name & Status Section (Read Only) */}
          <div className="mb-8 max-w-4xl flex gap-6">
            <div className="flex-1">
              <label className="block text-gray-500 text-sm font-bold mb-2 uppercase tracking-wide"><T>Role Name</T></label>
              <div className="w-full p-3 bg-gray-50 border border-gray-200 rounded-lg text-gray-700 font-medium">
                {roleName}
              </div>
            </div>

            <div className="w-48">
              <label className="block text-gray-500 text-sm font-bold mb-2 uppercase tracking-wide"><T>Status</T></label>
              <div className={`w-full p-3 border rounded-lg font-bold text-center ${status === 'Active' ? 'bg-green-50 text-green-700 border-green-200' : 'bg-red-50 text-red-700 border-red-200'}`}>
                {status}
              </div>
            </div>
          </div>

          {/* Permissions Grid (Read Only) */}
          <div className="space-y-8">
            {SYSTEM_MODULES.map((category, index) => (
              <div key={index} className="border rounded-xl overflow-hidden shadow-sm bg-white opacity-90">
                
                {/* Category Header */}
                <div className="bg-gray-100 px-6 py-3 border-b border-gray-200">
                  <h3 className="font-bold text-gray-700 text-base">
                    {category.category}
                  </h3>
                </div>

                {/* Modules */}
                <div className="p-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                  {category.modules.map((mod) => {
                    const isChecked = selectedPermissions.includes(mod.key);
                    return (
                      <label 
                        key={mod.key} 
                        className={`flex items-center space-x-3 p-3 rounded-lg border cursor-not-allowed ${
                          isChecked 
                            ? 'bg-emerald-50 border-emerald-200' 
                            : 'bg-white border-gray-100'
                        }`}
                      >
                        <div className="relative flex items-center">
                          <input 
                            type="checkbox" 
                            className="peer h-5 w-5 rounded-md border border-gray-300 bg-gray-100 checked:bg-emerald-500 checked:border-emerald-500 pointer-events-none"
                            checked={isChecked}
                            readOnly
                            disabled
                          />
                           {isChecked && (
                             <svg className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-3.5 h-3.5 pointer-events-none text-white" viewBox="0 0 14 14" fill="none">
                               <path d="M3 8L6 11L11 3.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                             </svg>
                           )}
                        </div>
                        <span className={`text-sm font-medium ${isChecked ? 'text-emerald-900' : 'text-gray-400'}`}>
                          {mod.label}
                        </span>
                      </label>
                    );
                  })}
                </div>
              </div>
            ))}
          </div>

          {/* Actions */}
          <div className="mt-10 flex justify-end border-t pt-6">
            <button 
              onClick={() => navigate('/admin/roles')} 
              className="px-8 py-2.5 bg-gray-800 text-white font-bold rounded-lg hover:bg-gray-900 transition shadow-lg"
            >
              &larr; Back to Role List
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewRole;